import { Form, Formik } from 'formik';
import { Modal } from 'app/shared/components/modals/Modal';
import { IAddSubGroup } from '../types';
import { addNewSubgroupValidationSchema } from '../constants';
import { AddNewSubgroupForm } from './AddNewSubgroupForm';

interface IConfigurationTableModalProps {
  addNewSubgroupModalPosition: number;
  handleSubmit: (data: IAddSubGroup) => void;
  handleClose: () => void;
}

export const AddNewSubgroupModal = ({ addNewSubgroupModalPosition, handleSubmit, handleClose }: IConfigurationTableModalProps) => {
  const initialConfigurationState: IAddSubGroup = {
    name: '',
    paramsType: '',
  };

  return (
    <Modal
      hideBackdrop
      title="Create Subgroup"
      open={!!addNewSubgroupModalPosition} 
      resetPosition={addNewSubgroupModalPosition}
      dialogWidth="700px" 
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialConfigurationState as IAddSubGroup}
        validationSchema={addNewSubgroupValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <AddNewSubgroupForm handleClose={handleClose} {...props} />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
